import {
  lectureExportResponseSchema,
  lectureListResponseSchema,
  lectureRecordResponseSchema,
  type LectureExportBody,
  type LectureSaveBody,
} from '@wx-weiqi/contracts';
import type { IdentityStore } from '../stores/identity-store';
import { nextRequestId } from './http';
export class LectureRecordClient {
  constructor(private readonly identity: Pick<IdentityStore, 'authorized'>) {}
  async list(after: string | null = null) {
    return (
      await this.identity.authorized(
        `/lecture-records${after ? `?after=${encodeURIComponent(after)}` : ''}`,
        lectureListResponseSchema,
      )
    ).data;
  }
  async get(id: string) {
    return (
      await this.identity.authorized(
        `/lecture-records/${encodeURIComponent(id)}`,
        lectureRecordResponseSchema,
      )
    ).data;
  }
  async save(id: string, body: LectureSaveBody, requestId: string) {
    return (
      await this.identity.authorized(
        `/lecture-records/${encodeURIComponent(id)}`,
        lectureRecordResponseSchema,
        { method: 'PUT', body, requestId },
      )
    ).data;
  }
  async export(records: LectureExportBody['records']) {
    return (
      await this.identity.authorized('/lecture-records/export', lectureExportResponseSchema, {
        method: 'POST',
        body: { records },
        requestId: nextRequestId('lecture-export'),
      })
    ).data.records;
  }
}
export type LectureRecordApi = Pick<LectureRecordClient, 'list' | 'get' | 'save' | 'export'>;
